var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.2,
    height: 23,
    viewBox: "0 0 23.2 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23.2V23H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_193",
    d: "M0 0H23V23H0z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_104",
    fill: "#1291d9",
    fillRule: "evenodd",
    d: "M270.954 14.375a2.875 2.875 0 1 0-2.921-2.875 2.907 2.907 0 0 0 2.921 2.875zm-5.988-9.2a8.278 8.278 0 0 1 3.505-1.869L269.639 0h2.921l1.168 3.306a10.25 10.25 0 0 1 3.505 1.869l3.505-.719 1.462 2.588-2.337 2.588a8.07 8.07 0 0 1 .146 1.869c0 .575-.146 1.294-.146 1.869l2.337 2.587-1.461 2.587-3.505-.719a8.278 8.278 0 0 1-3.505 1.869L272.561 23h-2.921l-1.168-3.306a10.25 10.25 0 0 1-3.505-1.869l-3.505.719L260 15.956l2.337-2.587a8.07 8.07 0 0 1-.146-1.869c0-.575.146-1.294.146-1.869L260 7.044l1.461-2.587z",
    transform: "translate(-259)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.cfea629e.svg";
export { ForwardRef as ReactComponent };